export var LayoutThemes = {
    default: 'default',
    min: 'min',
};
